// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2M-Rk","insightsList":"newBusinessInsightsMenu_insightsList__3GixK","active":"newBusinessInsightsMenu_active__-xijD"};